import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Configuracion } from 'src/app/model/configuration';


const STORAGE_KEY = 'state';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionService {
  private datosSubject: BehaviorSubject<Configuracion> = new BehaviorSubject<Configuracion>({ ejercicio: 0, esProcesoElectoral: false });
  
  constructor() {
    const stored = localStorage.getItem(STORAGE_KEY);
    if(stored) {
      this.datosSubject.next(JSON.parse(stored));
    }
  }

  public datos$ = this.datosSubject.asObservable();

  public actualizar(parcial: Partial<Configuracion>) {
    const actual = this.datosSubject.value;
    const actualizado = { ...actual, ...parcial };
    this.datosSubject.next(actualizado);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(actualizado));
  }

  public getDatos() {
    return this.datosSubject.value;
  }

  public limpiar() {
    const limpio: Configuracion = { ejercicio: 0, esProcesoElectoral: false };
    this.datosSubject.next(limpio);
    localStorage.removeItem(STORAGE_KEY);
  }
}

